import { z } from "zod";

export default {
  params: z.object({
    payoutId: z.number(),
    payoutStatus: z.enum(["CANCELED", "VALIDATED"]),
  }),
  response: z.object({
    success: z.boolean(),
  }),
};
